import React, { useState } from 'react';
import {
	ContentDiv,
	FlexWrapper,
	NavDiv,
	SettingsWrapper,
} from '../SkuAnalysis.styles';
import { ApButtonIcon, ApButtonTab, colors } from '@alixpartners/ui-components';
import CategoryDashboard from './CategoryDashboard';
import MarketEffectLineChart from './MarketEffect/MarketEffectChart/Charts/MarketEffectLineChart';
import SkuSettings from './SkuSettings/SkuSettings';
import Modal from 'CategoryManagement/CategoryWidget/Components/Modal/Modal';

const Dashboard = ({ setContent, content, filterSaved }) => {
	const [isSkuSetting, setIsSkuSetting] = useState(false);
	const INITIAL_SUBNAV_CONFIG = [
		{
			id: 0,
			name: 'dashboard',
			label: 'Dashboard',
			isActive: true,
			component: CategoryDashboard,
		},
		{
			id: 1,
			name: 'market-analysis',
			label: 'Market Analysis',
			isActive: false,
			component: MarketEffectLineChart,
		},
	];
	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);
	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};
	return (
		<>
			<FlexWrapper>
				<NavDiv>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={isActive}
							onClick={() => {
								subNavHandler(id);
							}}
							small
						>
							{label}
						</ApButtonTab>
					))}
				</NavDiv>
				<SettingsWrapper>
					<ApButtonIcon
						title={`Insights Settings`}
						iconName="settings"
						iconProps={{ iconColor: colors.grey8 }}
						onClick={() => setIsSkuSetting(true)}
					/>
				</SettingsWrapper>
			</FlexWrapper>

			<ContentDiv>
				{subNav.map(({ id, isActive, component: Component }) => {
					return (
						isActive && (
							<Component
								key={id}
								modelId={content}
								filterSaved={filterSaved}
								setContent={setContent}
							/>
						)
					);
				})}
				{isSkuSetting && (
					<Modal
						title="SKU Settings"
						isFullScreen={true}
						zIndex={2}
						closeLabel="Close"
						onClose={() => setIsSkuSetting(false)}
					>
						<SkuSettings />
					</Modal>
				)}
			</ContentDiv>
		</>
	);
};

export default Dashboard;
